import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import bankServices from '@src/services/banks.services';

export const getBankImagesList = createAsyncThunk(
  'getBankImagesList',
  async (body, { rejectWithValue }) => {
    try {
      const response = await bankServices.getBankImagesList();
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getInstantRemittanceBankImagesList = createAsyncThunk(
  'getInstantRemittanceBankImagesList',
  async (body, { rejectWithValue }) => {
    try {
      const response = await bankServices.getDirectWireTransferBankImages();
      return response;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  bankList: [],
  instantRemittanceBankList: [],
  currentBank: 'paymentLater',
};

export const bankSlice = createSlice({
  name: 'bank',
  initialState,
  reducers: {
    setCurrentBank(state, action) {
      state.currentBank = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBankImagesList.fulfilled, (state, action) => {
      state.bankList = action?.payload?.data?.items;
    });
    builder.addCase(getInstantRemittanceBankImagesList.fulfilled, (state, action) => {
      state.instantRemittanceBankList = action?.payload?.data?.items;
    });
  },
});

export const { setCurrentBank } = bankSlice.actions;
